<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="jump_to_top_3">Heidi kann brauchen, was es gelernt hat</h1>
<p class="noindent">Heidi ist zurückgekehrt zum Alpöhi. Der ist darüber so froh, dass er nach Jahrzehnten zum ersten Mal wieder die Kirche im Dörfli aufsucht, worüber die Dorfbewohner erstaunt, aber erfreut sind. Er setzt sein Haus im Dörfli wieder instand, damit Heidi den Winter dort verbringen und die Schule besuchen kann. Heidi überzeugt den Geißenpeter, lesen zu lernen.</p>
<p class="calibre2">Im folgenden Jahr hofft Heidi, dass Klara sie endlich besuchen kann. Aber erst kommt nur der Herr Doktor, um die Lage zu klären. Es gefällt ihm so gut, dass Klara tatsächlich im darauffolgenden Sommer nach einem Kuraufenthalt in Bad Ragaz in die Hütte des Alpöhi darf. Ein Diener trägt sie auf einem Stuhl auf den Berg hinauf.</p>
<p class="calibre2">Klara wird auf dem Heuboden einquartiert, auf dem Heidi so viele Jahre geschlafen hat. Wenig begeistert ist Peter, der eifersüchtig ist, weil Klara nun Heidis Aufmerksamkeit beansprucht. Das führt dazu, dass er eines Tages Klaras Rollstuhl in die Tiefe rollen lässt, sodass er zerstört wird.</p>
<p class="calibre2">Eines Tages will Heidi Klara mit auf die Alp nehmen; der Alpöhi trägt sie hinauf. Auf der Alp lernt Klara wieder das Gehen. Eine große Überraschung gibt es, als Vater und Großmutter Sesemann zu Besuch kommen: Klara kommt ihnen auf eigenen Beinen entgegen. Herr Sesemann verspricht dem Alpöhi, zusammen mit dem Doktor für Heidi zu sorgen, wenn er das nicht mehr kann.</p>
<p class="bildabsatz"><span class="bilderrahmen"><img alt="Bild: 054_Heidi_002.jpg" class="bild_ohne_rahmen" src="media/054_Heidi_002.jpg" title=""/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec000003.vue?0b13d7e9